var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 75,
    viewBox: "0 0 87 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stack"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Message",
    d: "M52.3418 11.3984C49.2016 9.58107 45.4663 9.10021 41.9683 10.0375L16.199 16.9424C8.89258 18.9001 4.57961 26.3742 6.52966 33.6519L12.0513 54.259C14.0014 61.5367 21.4996 65.846 28.78 63.8952L54.5492 56.9903C61.8295 55.0396 66.1712 47.5578 64.2212 40.2801L58.6995 19.673C57.7629 16.1776 55.4832 13.2099 52.3418 11.3984Z",
    fill: "url(#paint0_linear_210_1463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Message_2",
    opacity: 0.32,
    d: "M52.3418 11.3984C49.2016 9.58107 45.4663 9.10021 41.9683 10.0375L16.199 16.9424C8.89258 18.9001 4.57961 26.3742 6.52966 33.6519L12.0513 54.259C14.0014 61.5367 21.4996 65.846 28.78 63.8952L54.5492 56.9903C61.8295 55.0396 66.1712 47.5578 64.2212 40.2801L58.6995 19.673C57.7629 16.1776 55.4832 13.2099 52.3418 11.3984Z",
    fill: "url(#paint1_linear_210_1463)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Message_3",
    filter: "url(#filter0_f_210_1463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.204 18.1755C43.2227 16.9607 40.8796 16.6157 38.6966 17.2006L22.6149 21.5097C18.0553 22.7315 15.4151 27.5874 16.6954 32.3657L20.3207 45.8956C21.6011 50.6739 26.3318 53.5548 30.8752 52.3374L46.9568 48.0283C51.5002 46.8109 54.1583 41.9502 52.878 37.1719L49.2527 23.642C48.6377 21.347 47.1859 19.3865 45.204 18.1755Z",
    fill: "#FFAC82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    filter: "url(#filter1_b_210_1463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5357 24.9894C73.6752 22.1229 69.7869 20.5254 65.7449 20.5254H35.9677C27.5249 20.5254 20.7158 27.3375 20.7158 35.7471V59.5592C20.7158 67.9688 27.555 74.7809 35.9677 74.7809H65.7449C74.1575 74.7809 80.9997 67.9688 80.9997 59.5592V35.7471C80.9997 31.7081 79.3992 27.8499 76.5357 24.9894Z",
    fill: "#FF5630",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    filter: "url(#filter2_bd_210_1463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.7818 39.997L70.5406 40.2382L56.9436 51.1194C55.2587 52.4457 53.1759 53.1691 51.0388 53.1691C48.8957 53.1691 46.8491 52.4457 45.1611 51.1194L31.4465 40.419L31.0517 40.0272C30.3614 39.1229 30.4518 37.8268 31.2657 37.013C32.0463 36.1991 33.3425 36.1087 34.2799 36.802L47.8438 47.6531C49.6191 49.1029 52.1239 49.1029 53.8721 47.6531L67.4632 36.802C67.9183 36.38 68.5211 36.166 69.1541 36.1991C69.7539 36.2594 70.3297 36.5337 70.7486 36.9828C71.5022 37.857 71.5022 39.1229 70.7818 39.997Z",
    fill: "url(#paint2_linear_210_1463)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_210_1463",
    x: 0.37207,
    y: 0.922852,
    width: 68.8271,
    height: 67.6934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_210_1463"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_210_1463",
    x: 5.71582,
    y: 5.52539,
    width: 90.2842,
    height: 84.2554,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_210_1463"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_210_1463",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_210_1463",
    x: 15.5889,
    y: 21.1958,
    width: 70.7295,
    height: 46.9731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_210_1463"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.337255 0 0 0 0 0.188235 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_210_1463",
    result: "effect2_dropShadow_210_1463"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_210_1463",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_210_1463",
    x1: 3,
    y1: 20.479,
    x2: 63.5951,
    y2: 59.8491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_210_1463",
    x1: 3,
    y1: 20.479,
    x2: 63.5951,
    y2: 59.8491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B71D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_210_1463",
    x1: 68.4303,
    y1: 39.2608,
    x2: 23.29,
    y2: 42.7925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.e1812076e5009219b4c0229b264618b3.svg";
export { ForwardRef as ReactComponent };